/** 
 * 锚点导航
 */
import React, { Component } from 'react'
import classnames from "classnames";
import "./anchorNav.less";

class AnchorNav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeItem: 'formula-anchor0',// 目录激活项
      isSticky: false,// 是否吸顶
      showPager: false, // 是否显示tab翻页按钮
      pagerLeft: 0, // ul定位
      pagerLeftDisabled: true, // 上一页按钮默认禁用
      pagerRightDisabled: false, // 下一页按钮默认可点击
    };
  }
  componentDidMount() {
    // 绑定页面滚动事件
    setTimeout(() => {
      let contentArea = document.querySelector('ul.formula-tab-content');
      contentArea?.addEventListener("scroll", this.onPageScroll);
      let anchorWidth = document.querySelector('.anchor-list')?.offsetWidth;
      anchorWidth > 256 && this.setState({showPager: true});
      // console.log('anchorWidth', anchorWidth)
    }, 0);
  }
  componentWillReceiveProps(nextProps) {
    if(this.props.tabs.length !== nextProps.tabs.length) {
      const activeItem = nextProps.tabs[0]?.id;
      // console.log(activeItem)
      this.setState({activeItem}, this.setPager);
    }
  }
  componentWillUnmount() {
    // 解绑页面滚动事件
    window.removeEventListener("scroll", this.onPageScroll);
  }
  setPager = () => {
    const anchorNode = document.querySelector('.anchor-list');
    const anchorWidth = anchorNode?.offsetWidth;
    this.setState({showPager: anchorWidth > 256 ? true : false, pagerLeftDisabled: true, pagerRightDisabled: false, pagerLeft: 0 })
  }
  compare = (prop) => {
    return function (a, b) {
      const value1 = a[prop];
      const value2 = b[prop];
      return value1 - value2;
    };
  };

  // 页面滚动事件
  onPageScroll = (e) => {
    if (this.scrollTimer) {
      clearTimeout(this.scrollTimer);
    }
    this.scrollTimer = setTimeout(() => {
      const { tabs } = this.props;
      // 动态高亮
      const viewTops = [];
      const mainNavArea = document.querySelector('ul.anchor-list');
      // 导航栏 距可视区域顶部的距离
      const navOffsetTop = mainNavArea?.getBoundingClientRect().top;
      // 遍历父组件传入的导航
      for (let i=0; i<tabs.length; i++) {
        const { id, len } = tabs[i];
        // console.log('nav', len)
        const ele = document.getElementById(id);
        if (!ele) return;
        // 父组件传入的每个导航 距离可视区顶部的距离
        const top = ele?.getBoundingClientRect().top;
        const totalHeight = len * 24; // 每条24px，总高度为条数*24
        const l = len > 7 ? 7 : len; // 自制内容传入的len<4时
        // console.log('for in *** id：', id, ', totalHeight', totalHeight, ', top:', top, ', navOffsetTop:',navOffsetTop, )
        // top+一条标题的高度24+totalHeight<7条*24px+navOffsetTop+导航栏高度30，时应取消激活，激活下一项
        if (top + 24 + totalHeight < l*24 + navOffsetTop + 30) continue;
        viewTops.push({
          id,
          top,
        });
      }
      viewTops.sort(this.compare("top"));
      // console.log("viewTops", viewTops)
      viewTops.length && this.setState({
        activeItem: viewTops[0]?.id,
      });
    }, 90);
  };

  //跳转到的锚点
  onScrollToAnchor = (activeItem) => {
    if (activeItem) {
      // 找到锚点
      const anchorElement = document.getElementById(activeItem);
      // 如果对应id的锚点存在，就跳转到锚点
      if (anchorElement) {
        anchorElement.scrollIntoView({ block: "start", behavior: "smooth" });
        this.setState({
          activeItem,
        });
      }
    }
  };

  renderItem = () => {
    const { activeItem, pagerLeft } = this.state;
    const { tabs } = this.props;
    // console.log("activeItem", activeItem)
    return (
      <div className="anchor-list-wrap">
        <div className="anchor-list-scroll">
          <ul className={classnames('anchor-list')} style={{left: pagerLeft + 'px'}}>
            {tabs.map((item, index) => {
              // console.log("renderItem", item.id, activeItem)
              return (
                <li
                  key={index}
                  data-id={item.id}
                  onClick={() => this.onScrollToAnchor(item.id)}
                  className={activeItem === item.id ? 'anchor-li active' : "anchor-li"}
                >
                  <span
                    className={classnames('anchor-item')}
                  >
                    {item.name}
                  </span>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    );
  };
  // 点击tab翻页按钮
  handlePage = value => {
    let { pagerLeft } = this.state;
    let anchorListWrap = document.querySelector('.anchor-list-wrap')?.getBoundingClientRect(); // ul的可视区
    let anchorList = document.querySelector('.anchor-list')?.getBoundingClientRect(); // ul
    // console.log(anchorList.right-anchorListWrap.right)
    let prePageWidth = anchorListWrap.left-anchorList.left;
    let nextPageWidth = anchorList.right-anchorListWrap.right;
    let newPagerLeft;
    let pagerLeftDisabled;
    let pagerRightDisabled;
    if(value === 'prev') {
      newPagerLeft = prePageWidth > 206 ? pagerLeft + 206 : pagerLeft + prePageWidth;
      pagerLeftDisabled = prePageWidth <=206 ? true : false;
    } else if(value === 'next') {
      newPagerLeft = nextPageWidth > 206 ? pagerLeft - 206 : pagerLeft - nextPageWidth;
      pagerRightDisabled = nextPageWidth <=206 ? true : false;
    }
    this.setState({pagerLeft: newPagerLeft, pagerLeftDisabled, pagerRightDisabled})
  }
  // 渲染翻页按钮
  renderPager = () => {
    const { pagerLeftDisabled, pagerRightDisabled } = this.state;
    return (
      <div>
        <button className="anchor-nav-prev" onClick={() => this.handlePage('prev')} disabled={pagerLeftDisabled}> 
          <i className="iconfont icon-gongshibianjiqi-zuo"></i> 
        </button>
        <button className="anchor-nav-next" onClick={() => this.handlePage('next')} disabled={pagerRightDisabled}> 
          <i className="iconfont icon-gongshibianjiqi-you"></i>
        </button>
      </div>
    )
  }
  render() {
    const { showPager } = this.state;
    return (
      <div
        className={classnames(
          'formula-main-anchor',
          showPager? 'formulaEditor-padding32' : 'formulaEditor-padding18'
        )}
      >
        {showPager ? this.renderPager() : ''}

        {this.renderItem()}
      </div>
    );
  }
}

export default AnchorNav;
